export default __webpack_public_path__ + "static/media/karstenWhite.298ace63.webp";